/**
 * App-wide feature flags for UI entry points.
 * Flags only hide UI (navigation, tabs, context actions); implicit backend calls stay untouched.
 */

/**
 * Optimizations (optimizer suggestions/optimizations) are hidden because the optimizer is outdated.
 * Set to true to show the employee/course/institution tabs again and serve the /optimizations route.
 */
export const OPTIMIZATIONS_ENABLED = false;
